import { render } from "./dialogPanel.vue?vue&type=template&id=bc99d178&scoped=true"
import script from "./dialogPanel.vue?vue&type=script&lang=js"
export * from "./dialogPanel.vue?vue&type=script&lang=js"

import "./dialogPanel.vue?vue&type=style&index=0&id=bc99d178&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc99d178"]])

export default __exports__